const LOCATION_TYPE_NODE_TYPES = {
  LOCATION_TYPE: 'LOCATION_TYPE',
  LOCATION_TYPE_CATEGORY: 'LOCATION_TYPE_CATEGORY',
}

export default LOCATION_TYPE_NODE_TYPES
